import React from 'react';
import { t } from 'i18next';

const PrintToPDF = React.forwardRef(({ state }, ref) => {
    return (
        <a
            href={state?.DownloadURL}
            style={{ display: 'none' }}
            ref={ref}
        >{`${t('Finances.Invoices.InvoiceNumber')}${state?.InvoiceNumber}`}</a>
    );
});

export default PrintToPDF;
